import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-mechanical-connections-section',
    templateUrl: './mechanical-connections-section.component.html',
    styleUrls: ['./mechanical-connections-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class MechanicalConnectionsSectionComponent implements OnChanges {

  readonly selections = input.required<GuruEntity[]>();
  readonly invalidEntityNames = input.required<string[]>();
  readonly handArrangementImagePath = input.required<string>();
  readonly selectionChanged = output<GuruEntity>();
  arrangementSelection!: GuruEntity;
  returnAirSelection!: GuruEntity;
  supplyAirSelection!: GuruEntity;
  outsideAirSelection!: GuruEntity;
  paintOptionsSelection!: GuruEntity;
  wallMountSelection!: GuruEntity;
  rearDecoPanelSelection!: GuruEntity;
  collapsed: boolean = false;
  canExpand: boolean = true;
  private readonly selectionNames: string[] = ['USHandArrangment', 'USReturnAirOptions', 'USSupplyAirOptions', 'USOutsideAir', 'USPaintOptions', 'USWallMount', 'USRRDeco'];

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const filteredSelections: GuruEntity[] = this.selections().filter(selection => this.selectionNames.indexOf(selection.Name) >= 0);
    if (filteredSelections.length === 0) {
      this.collapsed = true;
      this.canExpand = false;
    } else {
      this.arrangementSelection = this.getSelectionWithName(this.selectionNames[0], filteredSelections);
      this.returnAirSelection = this.getSelectionWithName(this.selectionNames[1], filteredSelections);
      this.supplyAirSelection = this.getSelectionWithName(this.selectionNames[2], filteredSelections);
      this.outsideAirSelection = this.getSelectionWithName(this.selectionNames[3], filteredSelections);
      this.paintOptionsSelection = this.getSelectionWithName(this.selectionNames[4], filteredSelections);
      this.wallMountSelection = this.getSelectionWithName(this.selectionNames[5], filteredSelections);
      this.rearDecoPanelSelection = this.getSelectionWithName(this.selectionNames[6], filteredSelections);
    }
  }

  private getSelectionWithName(name: string, selections: GuruEntity[]): GuruEntity {
    for (const selection of selections) {
      if (selection.Name === name) {
        return JSON.parse(JSON.stringify(selection));
      }
    }
    return undefined!;
  }

  selectedValueChanged(selectionName: string, value: string): void {
    const entity: GuruEntity = new GuruEntity();
    entity.Name = selectionName;
    entity.Value = value;
    this.selectionChanged.emit(entity);
  }

  getExpansionIcon(): string {
    return this.collapsed ? 'arrow_drop_down' : 'arrow_drop_up';
  }

  toggleExpansion(): void {
    if (this.canExpand) {
      this.collapsed = !this.collapsed;
    }
  }

  isInvalidSelection(selectionName: string): boolean {
    return this.invalidEntityNames().indexOf(selectionName) >= 0;
  }

}
